import script from "./LoginFormComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginFormComponent.vue?vue&type=script&setup=true&lang=ts"

import "./LoginFormComponent.vue?vue&type=style&index=0&id=241a80f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-241a80f0"]])

export default __exports__